module.exports = __webpack_public_path__ + "static/media/feature.bdb5044e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeveDone/Millard/feature.jpg
// module id = 268
// module chunks = 0